module.exports = __webpack_public_path__ + "static/media/likes_hover.14c0a968.svg";